import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { QA_MENU, QA_CONTENT } from 'constants/controllers'

const getSectionUrl = (section, path, aol, flavour) => {
  const [root] = path
  const sectionId = root.id
  const focusedId = section.id

  return sectionId === focusedId
    ? url(QA_CONTENT, { aol, flavour, sectionId })
    : url(QA_CONTENT, { aol, flavour, focusedId, sectionId })
}

const QaResultPathBreadCrumbs = ({ path, aol, flavour, isLogged, setSignUpModalIsOpen }) => (
  <ul className='list-reset pl0 mt2 mb3 pseudo-arrows'>
    <li className='cadet-blue f7 di'>
      <a
        href={`${url(QA_MENU, { flavour })}#${aol}`}
        className='cadet-blue no-underline hover-underline'
      >
        {aol.toUpperCase()}
      </a>
    </li>
    {path.map((section, index) => (
      <li key={section.id} className='cadet-blue f7 di'>
        <a
          className='cadet-blue no-underline hover-underline'
          href={getSectionUrl(section, path, aol, flavour)}
        >
          {section.title}
        </a>
      </li>
    ))}
  </ul>
)

export default QaResultPathBreadCrumbs
